module.exports = __webpack_public_path__ + "static/img/95-3.10241d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/95-3.jpg
// module id = s0G+
// module chunks = 0